import { render } from "./Layout.vue?vue&type=template&id=09e6a1ac"
import script from "./Layout.vue?vue&type=script&lang=js"
export * from "./Layout.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Demo/Layout.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "09e6a1ac"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('09e6a1ac', __exports__)) {
    api.reload('09e6a1ac', __exports__)
  }
  
  module.hot.accept("./Layout.vue?vue&type=template&id=09e6a1ac", () => {
    api.rerender('09e6a1ac', render)
  })

}


export default __exports__